import Router from 'next/router'
import {
  reduxForm,
  formValueSelector,
  SubmissionError
} from 'redux-form'
import {
  compose,
  withStateHandlers,
  withHandlers,
  lifecycle,
  withProps,
  pure
} from 'recompose'
import { connect } from 'react-redux'

import { withInitialData } from '../components/hoc'
import {
  register,
  logIn
} from '../reducers/user'
import { scrollToFirstError, reduxErrorFormatter } from '../lib/validation'
import Register from '../components/Register'

const mapStateToProps = state => {
  const formSelector = formValueSelector('register')
  const selectedCountry = formSelector(state, 'address.country') || ''

  return {
    countries: state.global.regions.country.list,
    regions: state.global.regions.byCountry[selectedCountry] || [],
    loading: state.user.loading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    register: credentials => dispatch(register(credentials)),
    //logIn: credentials => dispatch(logIn(credentials))
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps({
    title: 'common:create-new-account',
    contentImage: ''
  }),
  withInitialData,
  lifecycle({
    componentDidMount() {
      if (this.props.isAuthenticated) {
        Router.push('/')
      }
    }
  }),
  withStateHandlers(
    {
      successfullRegistration: false
    },
    {
      setRegistrationState: () => val => ({ successfullRegistration: val })
    }
  ),
  withHandlers({
    _handleSubmit: props => data => {
      return props.register(data)
        .then(() => {
          props.createNotification({
            type: 'success',
            message: `${props.t('common:register-confirmation-email-response')}`
          })
          Router.push('/')
        })
        .catch(err => {
          let reduxFormErr = {
            _error: props.t('server-error')
          }

          if (err.response.status === 400) {
            reduxFormErr = {
              _error: props.t('form-vaidation-common-error'),
              ...reduxErrorFormatter(err.response.data)
            }
          } else {
            props.createNotification({
              type: 'error',
              message: props.t('server-error')
            })
          }
          throw new SubmissionError(reduxFormErr)
        })
    }
  }),
  reduxForm({
    destroyOnUnmount: false,
    initialValues: {
      user: {
        opt_in_email: true
      }
    },
    form: 'register',
    onSubmitFail: errors => scrollToFirstError(errors)
  }),
  pure
)(Register)



// WEBPACK FOOTER //
// ./pages/register.js